export default "assets/images/icons/back-c3dd025c.svg";